import { EmailPassword, IEmailPassword } from './email-password.model';
export { EmailPassword, IEmailPassword };
